import React from "react"

export default function BlockUser() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_171_8971)">
            <path d="M21.7223 18.3382L14.0863 12.4375C15.4869 11.9425 16.4966 10.6235 16.4966 9.0541C16.4966 7.06566 14.8851 5.4541 12.8966 5.4541C11.0094 5.4541 9.47945 6.91098 9.32757 8.75598L5.17632 5.54973C4.97945 5.39785 4.6982 5.4316 4.54351 5.62848L3.99226 6.33723C3.84038 6.5341 3.87413 6.81535 4.07101 6.96723L20.6198 19.7557C20.8166 19.9075 21.0979 19.8738 21.2526 19.6769L21.8038 18.9654C21.9557 18.7741 21.9191 18.49 21.7223 18.3382ZM6.59663 17.3341V18.5041C6.59663 19.2494 7.20132 19.8541 7.94663 19.8541H17.796L9.72976 13.6188C7.95226 13.9282 6.59663 15.4666 6.59663 17.3341Z" fill="#5B5E71" />
         </g>
         <defs>
            <clipPath id="clip0_171_8971">
               <rect width="18" height="14.4" fill="white" transform="translate(3.89648 5.4541)" />
            </clipPath>
         </defs>
      </svg>
   )
}
